export default __webpack_public_path__ + "static/media/mail-loading.524bd1f2.gif";